(() => {
  const PAGE_SIZE = 50;
  function node(tag, text, className) {
    const el = document.createElement(tag);
    if (text !== undefined) el.textContent = text;
    if (className) el.className = className;
    return el;
  }
  function parseTable(source, labels = {}) {
    const intro = [], rows = [];
    let heads = [];
    const chunks = Array.isArray(source) ? source : [source];
    chunks.forEach((chunk, chunkIndex) => {
      const lines = String(chunk || '').split(/\r?\n/).map(line => line.trim()).filter(Boolean);
      lines.forEach(line => {
        if (line.startsWith('#')) { intro.push(line.replace(/^#\s*/, '')); return; }
        const cells = line.split('|').map(cell => cell.trim());
        if (!heads.length) {
          if (chunkIndex === 0) { heads = cells; return; }
          heads = cells.map((_, index) => cells.length === 1 ? labels.model_column : labels.columns?.[index] || (labels.extra_column || '').replace(/\{\{\s*number\s*\}\}/g, index + 1));
        }
        if (cells.length === heads.length && cells.every((cell, index) => cell.toLowerCase() === heads[index].toLowerCase())) return;
        if (cells.length > heads.length) cells.splice(heads.length - 1, cells.length, cells.slice(heads.length - 1).join(' | '));
        while (cells.length < heads.length) cells.push('');
        rows.push(cells);
      });
    });
    return { intro, heads, rows };
  }
  function initialise(root) {
    if (root.dataset.ufReady || root.closest('[hidden]')) return;
    const data = root.querySelector('[data-uf-table-data]');
    if (!data) return;
    let source;
    try { source = JSON.parse(data.textContent); } catch (_) { return; }
    root.dataset.ufReady = 'true';
    let labels = {};
    try { labels = JSON.parse(root.querySelector('[data-uf-table-labels]')?.textContent || '{}'); } catch (_) {}
    const parsed = parseTable(source, labels);
    parsed.intro.forEach(text => root.append(node('p', text)));
    if (!parsed.heads.length || !parsed.rows.length) return;
    const heads = parsed.heads;
    const records = parsed.rows.map(cells => ({ cells, search: cells.join(' ').toLowerCase() }));
    const label = node('label', root.dataset.ufSearchLabel);
    const input = node('input');
    input.type = 'search'; input.placeholder = labels.search || ''; input.autocomplete = 'off';
    label.append(input); root.append(label);
    const wrap = node('div', undefined, 'uf-merchant-table-scroll');
    const table = node('table');
    table.append(node('caption', root.dataset.ufCaption, 'uf-visually-hidden'));
    const thead = node('thead'), header = node('tr');
    heads.forEach(text => { const th = node('th', text); th.scope = 'col'; header.append(th); });
    thead.append(header); table.append(thead);
    const tbody = node('tbody'); table.append(tbody); wrap.append(table); root.append(wrap);
    const nav = node('div', undefined, 'uf-merchant-table-nav');
    const previous = node('button', labels.previous), next = node('button', labels.next), status = node('span');
    previous.type = next.type = 'button';
    previous.setAttribute('aria-label', labels.previous_page); next.setAttribute('aria-label', labels.next_page);
    status.setAttribute('role', 'status'); status.setAttribute('aria-live', 'polite');
    nav.append(previous, status, next); root.append(nav);
    let page = 0;
    function render() {
      const term = input.value.trim().toLowerCase();
      const matches = term ? records.filter(record => record.search.includes(term)) : records;
      page = Math.min(page, Math.max(0, Math.ceil(matches.length / PAGE_SIZE) - 1));
      const start = page * PAGE_SIZE;
      const fragment = document.createDocumentFragment();
      matches.slice(start, start + PAGE_SIZE).forEach(record => {
        const tr = node('tr');
        for (let col = 0; col < heads.length; col++) tr.append(node('td', record.cells[col] || ''));
        fragment.append(tr);
      });
      if (!matches.length) { const tr = node('tr'), td = node('td', labels.no_results); td.colSpan = heads.length; tr.append(td); fragment.append(tr); }
      tbody.replaceChildren(fragment);
      status.textContent = matches.length ? (labels.results || '').replace(/\{\{\s*(start|end|count)\s*\}\}/g, (_, key) => ({ start: start + 1, end: Math.min(start + PAGE_SIZE, matches.length), count: matches.length })[key]) : labels.zero_results;
      previous.disabled = page === 0; next.disabled = start + PAGE_SIZE >= matches.length;
      previous.hidden = next.hidden = matches.length <= PAGE_SIZE;
    }
    input.addEventListener('input', () => { page = 0; render(); });
    previous.addEventListener('click', () => { page--; render(); });
    next.addEventListener('click', () => { page++; render(); });
    render();
  }
  function scan(scope = document) { scope.querySelectorAll('[data-uf-merchant-table]').forEach(initialise); }
  let scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; scan(); });
  }
  scan();
  const main = document.getElementById('MainContent') || document.body;
  new MutationObserver(schedule).observe(main, { attributes: true, attributeFilter: ['hidden'], childList: true, subtree: true });
  document.addEventListener('shopify:section:load', schedule);
})();

